import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { SchemaUtil } from '../utils/schema.util';
import { InputPlainObject } from '../plainObjects/input.plainObject';

export class InputVisitor extends BaseTransformationVisitor {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitOutputDefinition(outputDefinitionContext: any): void {
        (this.transformation as InputPlainObject).columns = SchemaUtil.getSchemaFromInputOutputDefinition(outputDefinitionContext);
    }
}
